import { CustomNavActions, UserTypes } from "../../constants/DomainConstants";
import { showToastrSuccess, showToastrError } from "../../util/toastr.js";
import transactieApi from "../../api/transactieApi";
import { getStore } from "../../store/configureStore";
import * as ajaxActions from "../../actions/ajaxCounterActions";
import * as exceptionActions from "../../actions/exceptionActions";
import * as customModalActions from "../../actions/customModalActions";
import redirector from "../../util/redirector";

const store = getStore();

export default function GetCustomAction(actionType, transactionId) {
    let action;
    switch (actionType) {
        case CustomNavActions.DIEN_IN:
            action = dienInTransactions(transactionId);
            break;
        default:
            action = null;
            break;
    }

    return action;
}

function dienInTransactions(transactionId) {
    return () => {
        store.dispatch(customModalActions.set({
            isOpen: true,
            handleUnsavedChanges: store.getState().session.hasUnsavedChanges,
            title: "Wijzigingsaanvraag indienen",
            message: "Hiermee geef je aan dat je wijzigingsaanvraag mag doorgestuurd worden naar Sport Vlaanderen om verder te verwerken",
            onCancel: () => { store.dispatch(customModalActions.reset()); },
            onConfirm: () => {
                store.dispatch(ajaxActions.started());
                transactieApi.setTransactieStatusToAangevraagd(transactionId)
                    .then((response) => {
                        showToastrSuccess('Bewaard');
                        const userType = store.getState().session.userType;
                        const hasOverzicht = userType === UserTypes.FEDERATIEMEDEWERKER || userType === UserTypes.GEMEENTEMEDEWERKER;
                        const overzichtUrl = hasOverzicht && userType === UserTypes.FEDERATIEMEDEWERKER ? "/federatie/overzicht" : "/gemeente/overzicht";
                        redirector.goTo(hasOverzicht ? overzichtUrl : '/sportorganisatie/eind/');
                        store.dispatch(ajaxActions.ended());
                        store.dispatch(customModalActions.reset());
                    })
                    .catch((ex) => {
                        store.dispatch(ajaxActions.failed());
                        showToastrError('Er ging iets mis, probeer opnieuw.');
                        exceptionActions.throwException(ex, true);
                    });
            }
        }));
    };
}